import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import { v4 } from 'uuid'
import { getPageSlug } from '../../utils'

import './LandingPageContentSection.scss'

const SectionContent = ({ section }) => (
  <div key={v4()} className="column">
    <h3 className="section-header">{section.title}</h3>
    <p
      className="title-lead"
      dangerouslySetInnerHTML={{
        __html: section.subtitle,
      }}
    />
    <div
      className="content"
      dangerouslySetInnerHTML={{
        __html: section.content.content,
      }}
    />
    {section.content.buttons && (
      <div className="buttons">
        {section.content.buttons.map(({ link }, index) => (
          <Link
            to={getPageSlug(link)}
            key={`btn-${index}`}
            className="button-light"
          >
            {link.title}
          </Link>
        ))}
      </div>
    )}
  </div>
)

class LandingPageContentSection extends React.Component {
  render() {
    const { section } = this.props

    return (
      <div
        className={`landing-page-content-section section is-medium ${section.section_type}`}
      >
        <div className="container">
          <div className="columns">
            {section.section_type === 'content-left' && (
              <SectionContent section={section} />
            )}
            <div className="column image-column">
              <Img
                fixed={section.content.image.localFile.childImageSharp.fixed}
              />
            </div>
            {section.section_type === 'content-right' && (
              <SectionContent section={section} />
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default LandingPageContentSection
